/**
 * LanguageListArrowContainer component.
 */
import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Props for LanguageListArrowContainer component.
 */
interface Props {
  offset?: number;
}

/**
 * Styled language list arrow container.
 */
const LanguageListArrowContainer = styled.div<Props>`
  top: ${({ offset }) => (-4 + (offset || 0)) * Screen.widthRatio}px;
  left: ${-45 * Screen.widthRatio}px;
  position: absolute;
`;

export default LanguageListArrowContainer;
